import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import { fullListShape, cpmPartnersDataShape, cpmWorkspaceGroupShape } from 'constants/PropTypesShapes';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// Models
import mPartner from 'models/cpm/partner';
// HOCS
import withFormManagement from 'hocs/WithFormManagement';
// Custom
import { cpmGetPartnersList } from 'actions';
import Callout from 'components/misc/Callout';
import SubListTemplate from 'components/templates/SubListTemplate';
import PartnerRow from 'cpmWorkspaces/assets/partner/PartnerRow';
import PartnerFilters from 'cpmWorkspaces/assets/partner/PartnerFilters';
import { invoke } from 'utils/Tools';

class CarparkPartnerChooseList extends React.Component {
  constructor(props) {
    super(props);

    this.handleSelectPartner = this.handleSelectPartner.bind(this);
    this.handleValidate = this.handleValidate.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);

    this.state = { showPartnerRequiredError: false };
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers
  handleSelectPartner(partner) {
    const { onFieldsChange } = this.props;
    onFieldsChange({ selectedPartner: partner });
    invoke(() => { this.setState({ showPartnerRequiredError: false }); });
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      fields: { selectedPartner },
      onValidate,
      partner,
    } = this.props;

    const carparkHasPartner = !_isNil(partner);

    if (_isNil(selectedPartner) && carparkHasPartner) {
      invoke(() => { this.setState({ showPartnerRequiredError: true }); });
      return false;
    }

    onValidate(selectedPartner);

    return true;
  }

  doGetRowComp(props) {
    return <PartnerRow {...props} />;
  }

  render() {
    const {
      fields: { selectedPartner },
      partners,
      defaultWorkspaceGroup,
      handleGetPartnersList,
    } = this.props;

    const { showPartnerRequiredError } = this.state;

    return (
      <SubListTemplate
        withQueryParams={false}
        name={mPartner.name}
        listFeatures={mPartner.listFeatures}
        withSelection
        onSelectElements={this.handleSelectPartner}
        elementsData={{
          loading: partners.loading,
          selectedElement: selectedPartner,
          elements: partners.elements,
          handleGetList: (p, s, f) => handleGetPartnersList({ workspaceId: defaultWorkspaceGroup.workspace.id }, p, s, f),
        }}
        additionalContent={showPartnerRequiredError ? (
          <Callout severity="error">
            <LocalizedMessage id="info.carparkSetting.partnerRequired" />
          </Callout>
        ) : null}
        filtersComp={<PartnerFilters />}
        rowComp={this.doGetRowComp}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  defaultWorkspaceGroup: _get(state.cpmCarpark.current.data, 'workspaceGroups.entries[0]'),
  partners: state.cpmPartner.list,
  handleCloseDialog: PropTypes.func.isRequired,
  handleOpenDialog: PropTypes.func.isRequired,
});

const mapDispatchToProps = (dispatch) => ({
  handleGetPartnersList: (data, pagination, sort, filters) => {
    dispatch(
      cpmGetPartnersList(mPartner.quelistPartners, data, {
        pagination,
        sort,
        filters,
      }),
    );
  },
});

CarparkPartnerChooseList.propTypes = {
  partner: cpmPartnersDataShape,
  partners: fullListShape.isRequired,
  defaultWorkspaceGroup: cpmWorkspaceGroupShape.isRequired,
  fields: PropTypes.object.isRequired,
  handleGetPartnersList: PropTypes.func.isRequired,
  onFieldsChange: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

CarparkPartnerChooseList.defaultProps = {
  partner: null,
};

const mapFieldsToProps = {
  selectedPartner: {
    resourceKey: 'partner',
    defaultValue: null,
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: ownProps,
});

module.exports = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withFormManagement(mapFieldsToProps, mapOwnPropsToResources),
)(CarparkPartnerChooseList);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/settings/CarparkPartnerChooseList.js